import { applyCursorDisabled } from "./cursor";
import { disabledOpacity } from "../utilities/design-system";
import { toString } from "@microsoft/fast-jss-utilities";
import { HighContrastColor, highContrastSelector } from "./high-contrast";
export function applyDisabledState(config /* @deprecated - this function doesn't need an argument */) {
    return Object.assign({ opacity: toString(disabledOpacity) }, applyCursorDisabled(), { [highContrastSelector]: {
            opacity: "1",
            color: HighContrastColor.disabledText,
        } });
}
